import classNames from 'classnames'
import cn from 'classnames'
import { IPartnerStatusIcon } from 'legacy/lut/features/partner360/configuration/models/IPartnerStatus'
import { CSSProperties, FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './PartnerStatusIcon.module.scss'

interface IPartnerStatusIconProps {
  profile: IPartnerStatusIcon
  className?: string
}

export const PartnerStatusIcon: FC<IPartnerStatusIconProps> = ({ profile, className }) => {
  const inlineStyles = useMemo<CSSProperties | undefined>(() => {
    if (!profile.Color) {
      return undefined
    }

    return {
      color: profile.Color,
    }
  }, [profile.Color])

  return (
    <Tooltip tipContent={() => <Translation text={profile.Info} span />}>
      <div className={cn(styles.icon, className)}>
        <i className={classNames(profile.Icon)} style={inlineStyles} />
      </div>
    </Tooltip>
  )
}
